type Props = {
  title?: string;
  statusLabel?: string;
};

/** Shared standalone loading view before the authenticated Admin layout exists. */
export function AdminLoadingScreen({
  title = 'Loading InkTap Admin', statusLabel = 'Loading Admin interface'
}: Props) {
  return <main className="admin-auth-gate" aria-busy="true">
    <div>
      <h1>{title}</h1>
      <div className="admin-auth-gate__spinner" role="status" aria-label={statusLabel} />
    </div>
  </main>;
}
